<template>
  <div class="filters-box">
    <ProviderSelection
            @providerSelected="providerSelected"
            @dateChanged="dateChanged"
            @onSearch="onSearch"
    />

    <Card size="small" :title="filterReasonsHeadline">
      <Row>
        <Col span="8">
          <Table
                  :columns='columns'
                  :loading="isLoading"
                  size="small"
                  :pagination="false"
                  class="filter-table"
                  :dataSource='filterData'
                  rowKey="title"
                  :customRow="customRow">
          </Table>
        </Col>
        <Col span="16">
          <Table
                  :columns='detailsColumns'
                  :loading="isLoadingFilteredVideos"
                  size="small" :pagination="false"
                  class="filter-table"
                  :data-source='filterDataDetails' />
        </Col>
      </Row>
    </Card>

  </div>
</template>

<script>

// <!--                  rowSelection={{-->
// <!--                    type: radio,-->
// <!--                    ...rowSelection,-->
// <!--                  }}-->

import {Button, Card, Col, DatePicker, Divider, Input, List, Layout, Radio, Row, Table, Tag, Sider} from 'ant-design-vue'
import ProviderSelection from './ProviderSelection'
import moment from 'moment'
import axios from 'axios'

const detailsColumns = [
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    width: '30%'
  },
  {
    title: 'IMDb',
    dataIndex: 'target_data.imdb_id',
    key: 'target_data.imdb_id',
    width: '10%'
  },
  {
    title: 'TVDB',
    dataIndex: 'target_data.tvdb_id',
    key: 'target_data.tvdb_id',
    width: '10%'
  },
  {
    title: 'TMDB',
    dataIndex: 'target_data.tmdb_id',
    key: 'target_data.tmdb_id',
    width: '10%'
  },
  {
    title: 'URL',
    dataIndex: 'source_data.url',
    key: 'source_data.url',
  }
]

const columns = [
  {
    title: 'Amount',
    dataIndex: 'count',
    key: 'count',
    sortOrder: 'descend',
    sorter: (a, b) => a.count - b.count
  },
  {
    title: 'Issue',
    dataIndex: 'title',
    key: 'title',
  }
]

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  getCheckboxProps: record => ({
    disabled: record.name === 'Disabled User',
    // Column configuration not to be checked
    name: record.name,
  }),
};

const PROVIDER_ID_MAP = {
  'Amazon': 'amazon',
  'Netflix': 'netflix',
  'Maxdome': 'maxdome',
  'Magenta TV': 'magenta_tv',
  'Joyn': 'joyn',
  'Sky Ticket': 'sky_ticket',
  'TV NOW': 'tvnow',
  'Disney+': 'disney_plus',
  'Apple TV+': 'apple_tv_plus',
  'iTunes Video': 'itunes_videw'
}

export default {
  name: 'Stats',
  props: [],
  components: {
    ProviderSelection,
    DatePicker,
    List,
    Button,
    Card,
    Row,
    Col,
    Radio,
    Input,
    Tag,
    Divider,
    Table,
    Layout,
    Sider
  },
  data () {
    return {
      loading: true,
      columns,
      detailsColumns,
      rowSelection,
      selectedDate: '2020-05-04',
      dateFormat: 'YYYY-MM-DD',
      providerDateMap: {},
      currentProvider: 'Amazon',
      results: [],
      filteredVideos: [],
      isLoading: false,
      cachedCollectionLists: {},
      selectedFilter: '',
      isLoadingFilteredVideos: false,
      pagination: {
        onChange: page => {
          console.log(page)
        },
        pageSize: 10,
        position: 'bottom',
        size: 'small',
        showQuickJumper: true
      },
    }
  },
  computed: {
    filterReasonsHeadline () {
      if (!this.results) {
        return 'No filter reasons for export ' + this.currentCollectionName
      } else {
        return this.results.length + ' filter reasons for export ' + this.currentCollectionName
      }
    },
    filterDataDetails () {
      return this.filteredVideos
    },
    filterData () {
      let statsDataList = []
      console.log('BERFORE', this.results)
      let key = 0
      for (const result of this.results) {
        const title = result.title
        const count = result.count

        console.log('BERFORE1')
        statsDataList.push({
          key,
          title,
          count
        })
        key += 1
      }
      console.log('BERFORE2', statsDataList)
      return statsDataList
    }
  },
  mounted () {
    this.fetchFilterData()
  },
  watch: {
    async selectedFilter (selectedFilterValue) {
      console.log('getting videos for filter', selectedFilterValue)

      let res = await axios.get(`${this.$hostname}/getFilteredVideos/${this.collectionName}/${selectedFilterValue}`);
      console.log('after request', res.data)

      this.filteredVideos = res.data.msg.videos

      this.isLoadingFilteredVideos = false
    }
  },
  methods: {
    moment,
    customRow (record) {
      return {
        on: {
          click: (event) => {
            console.log('click', record)
            if (record.title !== this.selectedFilter) {
              this.isLoadingFilteredVideos = true
              this.selectedFilter = record.title
            }
          }
        }
      }
    },
    providerSelected (provider) {
      console.log('provider selected:', provider)
      this.currentProvider = provider
      this.fetchFilterData()
    },
    dateChanged (newDate) {
      console.log('dateChanged selected:', newDate)
      this.selectedDate = newDate
      this.fetchFilterData()
    },
    async lookupProviderDateMap (date) {
      // let res = await axios.get(`${this.$hostname}/lookupProviderDateMap/${date}`);
      console.log('bef. request')
      let res = await axios.get(`${this.$hostname}/lookupProviderDateMap/${date}`);
      console.log('after request', res.data)

      return res.data;
    },
    onSearch (event) {
      console.log('search not supported')
    },
    async fetchCollectionsForDate (newDate) {
      if (!(newDate in this.cachedCollectionLists)) {
        console.log('Looking up filter collections for', newDate)
        this.providerDateMap = await this.lookupProviderDateMap(newDate)
        this.cachedCollectionLists[newDate] = this.providerDateMap
      } else {
        this.providerDateMap = this.cachedCollectionLists[newDate]
      }
      return this.providerDateMap
    },
    async fetchFilterData () {
      this.isLoading = true
      this.selectedFilter = ''
      this.filteredVideos = []
      const providerId = PROVIDER_ID_MAP[this.currentProvider]
      console.log('this.selectedProvider', providerId)
      await this.fetchCollectionsForDate(this.selectedDate) // update provider date map if needed

      if (providerId in this.providerDateMap) {
        this.results = []
        const filterDatetime = this.providerDateMap[providerId]
        this.collectionName = filterDatetime
        console.log('this.collectionName', this.collectionName)
        this.filterStats = await axios.get(`${this.$hostname}/getFilterStats/${this.collectionName}`);
        this.filterStats = this.filterStats.data.msg
        console.log('this.filterStats are:', this.filterStats)

        for (let filterReasonKey in this.filterStats.filterReasons) {
          this.results.push({
            title: this.filterStats.filterReasons[filterReasonKey].reason,
            count: this.filterStats.filterReasons[filterReasonKey].count
          })
        }
      } else {
        console.log('no new export for provider on that date')
        this.collectionName = ''
        this.results = []
      }
      this.isLoading = false
      if (this.providerDateMap[providerId]) {
        this.currentCollectionName = this.providerDateMap[providerId]
      } else {
        this.currentCollectionName = 'n.a.'
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filters-box {
  background-color: rgba(255,255,255,0.2);
  color: #000;
  overflow-y: scroll;
  width: calc(100vw - 150px);
}

.filter-reason-text {
  text-align: left;
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/VodFilters.vue